<template>
    <div>
        <card-header title="New Plan Transaction" icon="fa-plus"/>

        <card-body>
            <plan-transaction-form :transaction="newTransaction"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!newTransaction.title || !newTransaction.total|| !newTransaction.type"
                    ><i class="fas fa-plus mr-2"></i>New Transaction
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from "@/http_client";
    import PlanTransactionForm from "./PlanTransactionForm";
    import moment from "moment";

    export default {
        components: {PlanTransactionForm, CardHeader, CardToolbar, CardBody, CardFooter},
        props: ['card', 'props'],
        data() {
            return {
                newTransaction: {
                    type: null,
                    result: 'success',
                    is_complete: 1,
                    completed_at: new Date(),
                }
            };
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);

                let payload = {
                    user_id: this.props.userId,
                    plan_id: this.props.planId,
                    ...this.newTransaction
                };

                payload.created_at = (payload.created_at) ? moment(payload.created_at).format('YYYY-MM-DD HH:mm:ss') : null;
                payload.completed_at = (payload.completed_at) ? moment(payload.completed_at).format('YYYY-MM-DD HH:mm:ss') : null;
                payload.settled_at = moment().format('YYYY-MM-DD HH:mm:ss');

                payload.is_fee = (this.newTransaction.type === 'fee' || this.newTransaction.type === 'interest') ? 1 : 0;

                http.post(`payment-plans/${this.props.planId}/transactions`, payload, {force: true}).then(response => {
                    this.$reloadCard('payment-plan', {planId: this.props.planId});
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the transaction.');
                    this.$emit('loading', false);
                });
            }
        }
    };
</script>
